import { envConfig } from './constants/envConfig';

/* eslint-disable no-restricted-syntax */
const noop = () => {};

const safeConsoleMethod = <T extends keyof Console>(method: T): Console[T] => {
    if (envConfig.MODE !== 'development') {
        return noop as any;
    }

    return console[method];
};

export const safeConsole = {
    log: safeConsoleMethod('log'),
    warn: safeConsoleMethod('warn'),
    error: safeConsoleMethod('error'),
    info: safeConsoleMethod('info'),
    __dangerouslyAllowedInProduction: {
        // Do not use simple `log: console.log` here, Sentry Replay console logs will be broken
        log: (...data: any[]) => console.log(...data),
        warn: (...data: any[]) => console.warn(...data),
        error: (...data: any[]) => console.error(...data),
        info: (...data: any[]) => console.info(...data),
    },
};
